var chunkMapping = {
	"src_bootstrap_jsx-webpack_sharing_consume_default_react-dom_react-dom-webpack_sharing_consume-c0d0cf": [
		"webpack/container/remote/base/constants",
		"webpack/container/remote/base/stores",
		"webpack/container/remote/base/basecontainer",
		"webpack/container/remote/account/taskdelegationcheck",
		"webpack/container/remote/widgets/lazyloader",
		"webpack/container/remote/widgets/lazyremote",
		"webpack/container/remote/widgets/layouts",
		"webpack/container/remote/widgets/others",
		"webpack/container/remote/base/utils",
		"webpack/container/remote/base/accessctrl",
		"webpack/container/remote/base/topnav"
	],
	"webpack_container_remote_kfplatform_explorer_createflow": [
		"webpack/container/remote/kfplatform/explorer/createflow"
	],
	"webpack_container_remote_kfplatform_globaltask": [
		"webpack/container/remote/kfplatform/globaltask"
	],
	"webpack_container_remote_account_botconsent": [
		"webpack/container/remote/account/botconsent"
	],
	"webpack_container_remote_kfplatform_filePreview": [
		"webpack/container/remote/kfplatform/filePreview"
	],
	"webpack_container_remote_account_downloadbackupfile": [
		"webpack/container/remote/account/downloadbackupfile"
	],
	"webpack_container_remote_kfplatform_exportFile": [
		"webpack/container/remote/kfplatform/exportFile"
	],
	"webpack_container_remote_kfplatform_notification_notificationCenter": [
		"webpack/container/remote/kfplatform/notification/notificationCenter"
	],
	"webpack_container_remote_kfplatform_search_searchComponent": [
		"webpack/container/remote/kfplatform/search/searchComponent"
	],
	"webpack_container_remote_kfplatform_notification_notificationHome": [
		"webpack/container/remote/kfplatform/notification/notificationHome"
	],
	"webpack_container_remote_kfplatform_search_searchHome": [
		"webpack/container/remote/kfplatform/search/searchHome"
	],
	"webpack_container_remote_base_leftnav": [
		"webpack/container/remote/base/leftnav"
	],
	"src_work_platform_dashboard_home_index_jsx-webpack_sharing_consume_default_prop-types_prop-ty-b9d8d3": [
		"webpack/container/remote/base/classes",
		"webpack/container/remote/widgets/navigation",
		"webpack/container/remote/base/services",
		"webpack/container/remote/base/flowcard",
		"webpack/container/remote/widgets/inputs"
	]
};
var idToExternalAndNameMapping = {
	"webpack/container/remote/base/constants": [
		"default",
		"./constants",
		"webpack/container/reference/base"
	],
	"webpack/container/remote/base/stores": [
		"default",
		"./stores",
		"webpack/container/reference/base"
	],
	"webpack/container/remote/base/basecontainer": [
		"default",
		"./basecontainer",
		"webpack/container/reference/base"
	],
	"webpack/container/remote/account/taskdelegationcheck": [
		"default",
		"./taskdelegationcheck",
		"webpack/container/reference/account"
	],
	"webpack/container/remote/widgets/lazyloader": [
		"default",
		"./lazyloader",
		"webpack/container/reference/widgets"
	],
	"webpack/container/remote/widgets/lazyremote": [
		"default",
		"./lazyremote",
		"webpack/container/reference/widgets"
	],
	"webpack/container/remote/widgets/layouts": [
		"default",
		"./layouts",
		"webpack/container/reference/widgets"
	],
	"webpack/container/remote/widgets/others": [
		"default",
		"./others",
		"webpack/container/reference/widgets"
	],
	"webpack/container/remote/base/utils": [
		"default",
		"./utils",
		"webpack/container/reference/base"
	],
	"webpack/container/remote/base/accessctrl": [
		"default",
		"./accessctrl",
		"webpack/container/reference/base"
	],
	"webpack/container/remote/base/topnav": [
		"default",
		"./topnav",
		"webpack/container/reference/base"
	],
	"webpack/container/remote/kfplatform/explorer/createflow": [
		"default",
		"./explorer/createflow",
		"webpack/container/reference/kfplatform"
	],
	"webpack/container/remote/kfplatform/globaltask": [
		"default",
		"./globaltask",
		"webpack/container/reference/kfplatform"
	],
	"webpack/container/remote/account/botconsent": [
		"default",
		"./botconsent",
		"webpack/container/reference/account"
	],
	"webpack/container/remote/kfplatform/filePreview": [
		"default",
		"./filePreview",
		"webpack/container/reference/kfplatform"
	],
	"webpack/container/remote/account/downloadbackupfile": [
		"default",
		"./downloadbackupfile",
		"webpack/container/reference/account"
	],
	"webpack/container/remote/kfplatform/exportFile": [
		"default",
		"./exportFile",
		"webpack/container/reference/kfplatform"
	],
	"webpack/container/remote/kfplatform/notification/notificationCenter": [
		"default",
		"./notification/notificationCenter",
		"webpack/container/reference/kfplatform"
	],
	"webpack/container/remote/kfplatform/search/searchComponent": [
		"default",
		"./search/searchComponent",
		"webpack/container/reference/kfplatform"
	],
	"webpack/container/remote/kfplatform/notification/notificationHome": [
		"default",
		"./notification/notificationHome",
		"webpack/container/reference/kfplatform"
	],
	"webpack/container/remote/kfplatform/search/searchHome": [
		"default",
		"./search/searchHome",
		"webpack/container/reference/kfplatform"
	],
	"webpack/container/remote/base/leftnav": [
		"default",
		"./leftnav",
		"webpack/container/reference/base"
	],
	"webpack/container/remote/base/classes": [
		"default",
		"./classes",
		"webpack/container/reference/base"
	],
	"webpack/container/remote/widgets/navigation": [
		"default",
		"./navigation",
		"webpack/container/reference/widgets"
	],
	"webpack/container/remote/base/services": [
		"default",
		"./services",
		"webpack/container/reference/base"
	],
	"webpack/container/remote/base/flowcard": [
		"default",
		"./flowcard",
		"webpack/container/reference/base"
	],
	"webpack/container/remote/widgets/inputs": [
		"default",
		"./inputs",
		"webpack/container/reference/widgets"
	]
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = function(error) {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = function() {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = function(fn, arg1, arg2, d, next, first) {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then(function(result) { return next(result, d); }, onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = function(external, _, first) { return external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError(); };
			var onInitialized = function(_, external, first) { return handleFunction(external.get, data[1], getScope, 0, onFactory, first); };
			var onFactory = function(factory) {
				data.p = 1;
				__webpack_require__.m[id] = function(module) {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}